import React from 'react';
import ReactDOM from 'react-dom';
import ShiftState from '../ShiftState';
import StateFactory from '../StateFactory';

function Inactive () {
    return <div className="Inactive">
        <div className="Inactive-left">
            <div className="logo">
                <img alt="logo" src="https://cdn.shiftplatform.tv/ui_assets/logo-shift-ui-small.svg"/>
            </div>
            <div className="first">Reactivate <br/>your device.</div>
            <div className="second">
                Contact us:<br/>
                support@shiftplatform.tv
            </div>
        </div>
        <div className="Inactive-right">
            <img alt="logo" src="https://cdn.shiftplatform.tv/ui_assets/reactivateDevice.svg"/>
        </div>
    </div>;
}

class InactiveState extends ShiftState {

    get name () {
        return 'inactive';
    }

    preload () {
        ReactDOM.render(<Inactive/>, this.node);

        return super.preload();
    }
}

StateFactory.register('inactive', InactiveState, 10);

export default InactiveState;
